export default __webpack_public_path__ + "static/media/pp-icon.e0b176af.svg";